import IconButton from '@mui/material/IconButton';
import React from 'react';
import AvatarExaminee from '~/components/AvatarExaminee';
import DialogUserActions from '~/components/DialogUserActions';
import DialogUserDetails from '~/components/DialogUserDetails';
import Footer from '~/components/Footer';
import TopHeader from '~/components/TopHeader';
import { ROUTES } from '~/constants/ROUTES';
import getIcon from '~/helpers/getIcon';
import { StyledAvatarSmall, StyledBadge, StyledContentContainer } from './styles';
const IconSettings = getIcon('general.settings');
export interface ExamineeLayoutProps {
  centerElement?: React.ReactNode;
  children: React.ReactNode;
  disableFooter?: boolean;
}
export const ExamineeLayout: React.FC<ExamineeLayoutProps> = ({
  centerElement,
  children,
  disableFooter
}: ExamineeLayoutProps): React.ReactElement<ExamineeLayoutProps> => {
  const [openUserDetails, setOpenUserDetails] = React.useState(false);
  const [openActions, setOpenActions] = React.useState(false);
  return <>
      <TopHeader centerElement={centerElement} logoHref={{
      pathname: ROUTES.INDEX
    }} rightElement={<>
            <IconButton aria-label="Examinee Avatar" onClick={() => {
        setOpenActions(true);
      }}>
              <StyledAvatarSmall>
                <IconSettings color="primary" />
              </StyledAvatarSmall>
            </IconButton>

            <StyledBadge onClick={() => {
        setOpenUserDetails(true);
      }} overlap="circular">
              <AvatarExaminee size={110} />
            </StyledBadge>
          </>} data-sentry-element="TopHeader" data-sentry-source-file="index.tsx" />

      <StyledContentContainer aria-roledescription=" " data-sentry-element="StyledContentContainer" data-sentry-source-file="index.tsx">
        {children}
      </StyledContentContainer>

      {!disableFooter && <Footer />}

      <DialogUserDetails onClose={() => setOpenUserDetails(false)} open={openUserDetails} data-sentry-element="DialogUserDetails" data-sentry-source-file="index.tsx" />
      <DialogUserActions onClose={() => setOpenActions(false)} open={openActions} data-sentry-element="DialogUserActions" data-sentry-source-file="index.tsx" />
    </>;
};
export default ExamineeLayout;